import * as NavigationMenu from 'primitives/navigation-menu'

import { NavigationItem } from './navigation-item'
import * as MenuItem from '../menu-item'
import { UserAvatar } from '../avatar'
import { useHeaderContext, useTranslations } from '../../contexts/header-config-context'
import { useUserData } from '@repo/cf-user/contexts/auth'
import { useIsLoggedIn } from '../../hooks/use-auth'
import type { NavItem } from '../../hooks/use-nav-items'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { studioBaseUrl } from '../../utils/urls'

export function UserMenu() {
  const userData = useUserData()
  const isLoggedIn = useIsLoggedIn()
  const { isHomepage } = useHeaderContext()

  const t = useTranslations()

  if (!isLoggedIn) {
    return null
  }

  const triggerLink =
    isHomepage && userData
      ? `${studioBaseUrl}/creator/${userData.slug}/`
      : AppRoutes.SOCIAL_CURATED_FEED
  const triggerTarget = isHomepage && userData ? '_blank' : undefined

  const menuItems: NavItem = {
    name: 'user',
    link: triggerLink,
    subMenuItems: userData
      ? [
          {
            name: t('account.my_account'),
            link: '/my-account/',
          },
          {
            name: t('account.profile'),
            link: `/crafter/${userData.slug}/`,
          },
          {
            name: t('account.downloads'),
            link: '/my-account/license-keys-overview/',
          },
          {
            name: t('account.product_feed'),
            link: '/following/',
          },
          {
            name: t('account.store_credit'),
            link: '/store-credit/',
          },
          {
            name: t('account.affiliate_dashboard'),
            link: '/affiliate-area/?tab=urls',
          },
        ]
      : [],
  }

  return (
    <NavigationItem
      key="user"
      trigger={
        <NavigationMenu.Trigger className="focus:bg-cf-lavender" data-testid="user-menu-button">
          <MenuItem.Link
            href={triggerLink}
            target={triggerTarget}
            rel={triggerTarget ? 'noopener noreferrer' : undefined}
            className="flex-col gap-0.5"
          >
            <UserAvatar />
            <span className="grow whitespace-nowrap">{t('top_nav.account')}</span>
          </MenuItem.Link>
        </NavigationMenu.Trigger>
      }
      className="pb-4"
      item={menuItems}
    />
  )
}
